<header id="header">
  <div class="container-fluid p-0">
    <div class="header-firstnav">
      <div class="container">
        <div class="d-flex align-items-center justify-content-between">
          <nav>
            <ul>
              <li><span>regione puglia >&nbsp;</span></li>
              <li><span><strong>&nbsp;Amministrazione Trasparente</strong></span></li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div class="header-secondnav">

      <div class="container">
        <div class="site-name d-flex flex-row justify-content-between">
          <a [href]="currentHref" class="col"
            style="text-decoration: none; color: inherit; display: flex; align-items: center;width: fit-content;">
            <img src="assets/img/logo.svg" alt="Logo"
              style="max-width: 50px; height: auto; margin-right: 10px;">
            <div>
              <strong style="color: #000 !important; display: block;">Amministrazione Trasparente</strong>
              <span style="color: #555 !important; display: block;">regione puglia</span>
            </div>
          </a>
          <div class="col-3">
            <!--             <search></search>
 -->
          </div>
        </div>
      </div>
    </div>
  </div>
</header>